import React from "react";
import Accordion from "../../../../component/accordion/Accordion";
import { responsiveSettings } from "../../../../config/clients/clients";
import Image from "../../../../component/image/Image";
import chevronOrange from "../../../../assets/images/clients/chevron-orange.svg";

const TemplateOneFragment = (props: any) => {    
    const { menuSettings, submenuItems } = props;
    return (
        <> 
            <div className="sub-menu-parent">
                <ul className="sub-menu template7-accordion-container">
                    {
                        submenuItems?.map((columnItem:any, columnIndex:any) => {
                            return (
                                <Accordion
                                    responsiveBreakPoint={320}
                                    key={columnIndex}
                                    controllerElement={(isExpanded:any) => (
                                    <h2 className="accordion-action-header">{columnItem.name}</h2>                                
                                    )}
                                >
                                    <ul className="sub-menu">
                                        {
                                            columnItem?.items.map((menuItem:any, rowIndex:any) => {
                                                return (
                                                    <li key={rowIndex}>
                                                        <a href={menuItem.href} title={menuItem.name}  rel="noreferrer" target="_blank"> {menuItem.name} </a>
                                                        <span className="icon-arrow-right nav-sm-icon"></span>
                                                    </li>
                                                );
                                            })
                                        }
                                    </ul>
                                 </Accordion>
                            );
                        })
                    }
                </ul>
            </div>
        </>
    );
};


export default TemplateOneFragment;